import { RootState } from '@/App/store';

export const selectShowError = (state: RootState) => state.ui.showError;
